import { useEffect, useState } from "react";
import axios from "axios";

const EditPppSecretModal = ({
  isOpen,
  onClose,
  data,
  usermanId,
  onSuccess,
}) => {
  const [loadingProfiles, setLoadingProfiles] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [profiles, setProfiles] = useState([]);

  const [form, setForm] = useState({
    name: "",
    password: "",
    service: "pppoe",
    profile: "",
    caller_id: "",
    routes: "",
    ipv6_routes: "",
    comment: "",
    customer_id: "",
    disabled: false,
  });

  useEffect(() => {
    if (!data) return;

    setForm({
      name: data.name || "",
      password: "",
      service: data.service || "pppoe",
      profile: data.profile || "",
      caller_id: data.caller_id || "",
      routes: data.routes || "",
      ipv6_routes: data.ipv6_routes || "",
      comment: data.comment || "",
      customer_id: data.customer_id || "",
      disabled: Boolean(data.disabled),
    });
  }, [data]);

  useEffect(() => {
    if (isOpen && usermanId) {
      loadProfiles();
    }
  }, [isOpen, usermanId]);

  const loadProfiles = async () => {
    try {
      setLoadingProfiles(true);

      const token = localStorage.getItem("token");

      const res = await axios.get(
        `https://api.wifikamu.my.id/ppp-profile-by-device/${usermanId}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      setProfiles(res.data.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingProfiles(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSubmitting(true);

      const token = localStorage.getItem("token");

      await axios.put(
        "https://api.wifikamu.my.id/ppp-secret/update",
        {
          userman_id: usermanId,
          ppp_secret_id: data.id,
          ...form,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      onSuccess?.();
      onClose();
    } catch (error) {
      alert(error?.response?.data?.message || "Failed update PPP Secret");
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen || !data) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="w-full max-w-3xl bg-white dark:bg-slate-900 rounded-xl shadow-xl">
        <div className="border-b dark:border-slate-700 px-6 py-4">
          <h2 className="font-semibold text-lg">Edit PPP Secret</h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="grid md:grid-cols-2 gap-4 p-6">
            <div>
              <label className="text-sm">Username</label>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                className="w-full mt-1 px-3 py-2 rounded border dark:bg-slate-800 dark:border-slate-700"
              />
            </div>

            <div>
              <label className="text-sm">Password</label>
              <input
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Kosongkan jika tidak diubah"
                className="w-full mt-1 px-3 py-2 rounded border dark:bg-slate-800 dark:border-slate-700"
              />
            </div>

            <div>
              <label className="text-sm">Service</label>

              <select
                name="service"
                value={form.service}
                onChange={handleChange}
                className="w-full mt-1 px-3 py-2 rounded border dark:bg-slate-800 dark:border-slate-700"
              >
                <option value="pppoe">PPPoE</option>
                <option value="any">Any</option>
                <option value="pptp">PPTP</option>
                <option value="l2tp">L2TP</option>
                <option value="sstp">SSTP</option>
              </select>
            </div>

            <div>
              <label className="text-sm">Profile</label>

              <select
                name="profile"
                value={form.profile}
                onChange={handleChange}
                className="w-full mt-1 px-3 py-2 rounded border dark:bg-slate-800 dark:border-slate-700"
              >
                {profiles.map((item) => (
                  <option key={item.id} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="text-sm">Customer ID</label>

              <input
                name="customer_id"
                value={form.customer_id}
                onChange={handleChange}
                className="w-full mt-1 px-3 py-2 rounded border dark:bg-slate-800 dark:border-slate-700"
              />
            </div>

            <div>
              <label className="text-sm">Caller ID</label>

              <input
                name="caller_id"
                value={form.caller_id}
                onChange={handleChange}
                className="w-full mt-1 px-3 py-2 rounded border dark:bg-slate-800 dark:border-slate-700"
              />
            </div>

            <div className="md:col-span-2">
              <label className="text-sm">Comment</label>

              <textarea
                rows={3}
                name="comment"
                value={form.comment}
                onChange={handleChange}
                className="w-full mt-1 px-3 py-2 rounded border dark:bg-slate-800 dark:border-slate-700"
              />
            </div>

            <div className="md:col-span-2">
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name="disabled"
                  checked={form.disabled}
                  onChange={handleChange}
                />
                Disabled
              </label>
            </div>
          </div>

          <div className="border-t dark:border-slate-700 px-6 py-4 flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded border"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={submitting}
              className="px-4 py-2 rounded bg-blue-600 text-white"
            >
              {submitting ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPppSecretModal;
